import { useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import Breadcrumb from 'react-bootstrap/Breadcrumb';

import { AuthContext } from '../../../src/store/AuthContext';
import AlertCustomizado from "../../components/Alert";
import ToastCustomizado from "../../components/Toast";

const Erro = () => {

  const { erro, setErro } = useContext(AuthContext);
  const [show, setShow] = useState<boolean>(false);

  useEffect(() => {

    if(Object.keys(erro).length === 0 || (erro?.texto === '' && erro?.tipo === '')) setErro({ delay: 5000, tipo: 'danger', texto: `Alerta : Erro desconhecido. Contacte o Administrador!`, url: '/erro' });
  //eslint-disable-next-line react-hooks/exhaustive-deps
  },[]);

  return (

    <>

      <Breadcrumb>
            <Breadcrumb.Item linkAs={Link} linkProps={{ to: "/" }}>Home</Breadcrumb.Item>
            <Breadcrumb.Item active>{'Erro'}</Breadcrumb.Item>
      </Breadcrumb>

      {
        erro?.texto !== '' && erro?.tipo !== '' && erro?.url === '/erro' ?
          <div>
            <AlertCustomizado
              mensagem={erro && erro.texto ? erro.texto : undefined}
              tipo={erro && erro.tipo ? erro.tipo : ''}
              delay={300000}
            />

            <ToastCustomizado
              show={show}
              setShow={setShow}
              mensagem={erro && erro.texto ? erro.texto : undefined}
              tipo={erro && erro.tipo ? erro.tipo : ''}
              delay={300000}
            />

          </div>

          : null
      }

    </>

  );
}

export default Erro